module.exports = __webpack_public_path__ + "static/media/back.eb81154c.jpg";